module.exports = __webpack_public_path__ + "static/media/funda.8af00047.jpg";